import React, { useEffect, useState } from 'react';
import { Hero } from './components/Hero';
import { Advantages } from './components/Advantages';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Contact } from './components/Contact';
import { AgencyPopup } from './components/AgencyPopup';
export function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [hasSeenPopup, setHasSeenPopup] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (hasSeenPopup) return;
      const scrollPosition = window.scrollY + window.innerHeight;
      const totalHeight = document.documentElement.scrollHeight;
      if (scrollPosition > totalHeight / 2) {
        setShowPopup(true);
        setHasSeenPopup(true);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasSeenPopup]);
  return <div className="min-h-screen bg-[#F4F3F0] font-sans text-[#111111] selection:bg-[#111111] selection:text-[#F4F3F0]" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Advantages data-id="element-3" />
        <Services data-id="element-4" />
        <Process data-id="element-5" />
        <Contact data-id="element-6" />
      </main>

      <AgencyPopup isOpen={showPopup} onClose={() => setShowPopup(false)} data-id="element-7" />
    </div>;
}